import React from 'react';
import PropTypes from 'prop-types';
import RecordingListItem from './recording-list-item';

// TODO pass consultation and member objects as props
const RecordingList = ({ recordings, containerStyle }) => (
  <div className="ehr_content" id="recordings" style={containerStyle}>
    <table className="table">
      <thead>
        <tr>
          <th>Date of Call</th>
          <th>Recorded Call</th>
        </tr>
      </thead>
      <tbody>
        {
            recordings.length !== 0
            ? recordings.map(source =>
              <RecordingListItem
                key={source.sid}
                createDateTime={new Date(source.date_created)}
                sid={source.sid}
              />
              )
            : (
              <tr>
                <td>
                  <p>There are no conference recordings for this consultation.</p>
                </td>
              </tr>
              )
          }
      </tbody>
    </table> </div>
  );

RecordingList.propTypes = {
  containerStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  recordings:     PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.string, PropTypes.string]))).isRequired
};
export default RecordingList;
